<template lang="pug">
#linkShareContainer
  .centerBox(v-if="isNeedPwd === 0")
    p 请输入提取码
    el-input(v-model='code'  placeholder='请输入提取密码' size="small")
    el-button(type='primary' @click='extractBtn' size="small") 提取文件
  .centerBox(v-if="isTimeOu")
    p 文件下载
    img(src='../../../assets/public/noDatas.png' alt='等你等的链接都失效了')
  .centerBox2(v-if="isNeedPwd !== 0 && !isTimeOu" v-loading="loadBoolean")
    .title 分享文件
    .shareInfo
      img.userAvator(v-if="allMessage.img" :src="allMessage.img")
      .avatortox(v-else) {{allMessage.tox}}
      .info
        .nav
          span(style='font-size: 14px;color: #70798C;') 文件分享-
          el-breadcrumb(ref='breadDiv' separator='/')
            el-breadcrumb-item(v-for='(item, index) in navList' :key='index' style='cursor: pointer')
              span.ellipsis(@click='index !== (navList.length - 1) && clickBread(item,index)' :class=" index === (navList.length - 1) ? 'active' : '' ")
                | {{ item.name}}
        .shareN 分享时间：
          span(style='color:var(--key-color)') {{allMessage.shareDate}}
        .shareN(style='display: flex')
          p(style='margin-right:20px')
            span 分享人：
            span(style='color:var(--key-color)') {{allMessage.operUserName}}
          p
            span 有效期限：
            span(style='color:var(--key-color)') {{validityPeriod}}
      .right
        el-button(type="primary" size="small"  :disabled="!canDown" v-if="isDownload === 1" @click="batchDown") 下载
        img.icon(:src="iconImg" @click="changType")
    .list(v-if="tableType")
      el-table(ref='singleTable' height="420" :data='shareArr' border @selection-change="handleSelectionChange")
        el-table-column(type="selection" width="55" align="center" :selectable="judgeSelect")
        el-table-column(show-overflow-tooltip property='folderName' label='文件名称' align='left')
          template(#default='{ row }')
            .fileName(@click="clickFolderOrFile(row,'web')")
              img(:src='nameIcon(row)')
              | {{ row.folderName }}
        el-table-column( property="updateDate" label="修改时间" align="center")
          template(#default='{ row }')
            | {{operDate(row)}}
        el-table-column( property="fileSize" label="文件大小" align="center" width="120")
        el-table-column( label="操作" align="center" v-if="isDownload === 1" width="100")
          template(#default='{ row }')
            img.cursop(:src='downrul' title="下载"  alt  @click='fileDownload(row)')
    .listIcon(v-else)
      el-checkbox-group(v-model="checkList" )
        .shareItem(v-for="(row,index) in shareArr" :key="index" :title="row.folderName" )
          el-checkbox.listcheck(:label="row.folderId" :disabled="row.fileType === 10") &nbsp;
          img(:src='nameIcon(row)' @click.stop="clickFolderOrFile(row,'web')")
          .name(@click.stop="clickFolderOrFile(row,'web')") {{row.folderName}}
</template>

<script>
import shareCommon from "./../shareCommon";
import docRequest from "@/CommonDP/service/integratedModel-service";
import { downloadFile, shareDownloadUrl } from "@/CommonDP/utils";
import { getEnterpriseId } from "@/CommonDP/utils/auth";

export default {
  mixins: [shareCommon],
  data () {
    return {
      isNeedPwd: '', // 是否需要提取码
      isTimeOu: false, // 是否失效
      backupsArr: [],
      navList: [], // 文件夹层级
      shareArr: [], // 展示列表
      isDownload: '', // 是否有下载权限
      shareToken: '', // 分享人
      argument: {
        folderId: "",
        prjId: "",
        isRead: 1,
        priviAll: "1",
        versionId: "",
        versionName: "",
        isNew: "",
        userId: ""
      },
      downrul: require("@/CommonDP/assets/public/down.png"),
      code: '',
      loadBoolean: false,
      tableType: true,
      multipleSelection: [],
      checkList: []
    };
  },
  computed: {
    iconImg() {
      return this.tableType ? require("../icon/table.png") : require("../icon/list.png");
    },
    canDown() {
      return this.multipleSelection.length > 0 || this.checkList.length > 0;
    },
    validityPeriod() {
      return this.allMessage.endDate === "2099-12-31 23:59:59" ? "永久有效" : this.allMessage.endDate;
    }
  },
  methods: {
    fileDownload(row) {
      if (row.isFile === 1 || row.isFolder === 1) {
        const { folderId, folderName } = row;
        const { prjId, userId } = this.argument;
        this.exeDownloadFolder(prjId, folderId, folderName, userId);
      } else {
        this.doDownloadFile(row);
      }
    },
    async doDownloadFile(row) {
      await this.getShareToken();
      const { folderId, fileVersion: version } = row;
      const fileUrl = shareDownloadUrl(folderId, version, this.shareToken);
      downloadFile(fileUrl);
    },
    changType() {
      this.tableType = !this.tableType;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val || [];
    },
    async exeDownloadFolder(prjId, folderId, fileName, userId) {
      await this.getShareToken();
      var params = {
        folderId: folderId,
        rootDirectory: fileName,
        prjId: prjId,
        enterpriseId: getEnterpriseId("enterpriseId"),
        userId: userId
      };
      docRequest.downloadSharefolder(this.shareToken, params).then((response) => {
        const fileName = params.rootDirectory + ".zip";
        if ("msSaveOrOpenBlob" in navigator) {
          // 兼容ie
          window.navigator.msSaveOrOpenBlob(response, fileName);
          return;
        } else {
          const link = document.createElement("a");
          const blob = response;
          link.style.display = "none";
          link.href = URL.createObjectURL(blob);
          link.setAttribute("download", decodeURI(fileName));
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      });
    },
    batchDown() {
      if (this.tableType) {
        this.multipleSelection.forEach(async row => {
          await this.doDownloadFile(row);
        });
      } else {
        const list = this.shareArr.filter(e => this.checkList.some(i => i === e.folderId));
        list.forEach(async row => {
          await this.doDownloadFile(row);
        });
      }
    },
    judgeSelect(row, index) {
      return row.fileType !== 10; // 返回true该行可选，返回false则不可选
    },
    operDate(row) {
      return row.operDate || row.checkInDate;
    }
  }

};
</script>

<style lang="scss" scoped>
#linkShareContainer{
  width: 100%;
  height: 100%;
  background-image: url('../../../assets/public/shareBg2.png');
  background-position: bottom;
  background-size: 100%;
  background-repeat: no-repeat;
  background-color: #EEF2F6;
  .centerBox{
    width: 600px;
    height: 600px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translateX(-50%) translateY(-50%);
    background-color: var(--key-color)9e;
    box-sizing: border-box;
    border-radius: 300px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    p{
      color:#fff;
      font-size:22px
    }
    .el-input,.el-button{
      margin-top: 10px;
      width: 350px;
    }
  }
  .centerBox2{
    width: 780px;
    height: 600px;
    box-shadow: rgba(60,60,60,0.45);
    background-color: rgba(255, 255, 255, 0.95);
    position: absolute;
    left: 50%;
    top: 40%;
    transform: translateX(-50%) translateY(-40%);
    border-radius: 10px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    padding-bottom: 10px;
    .title{
      padding-left: 20px;
      height: 50px;
      line-height: 50px;
      font-size: 16px;
      font-weight: 600;
      border-bottom: 1px solid rgba(46, 91, 255, 0.1);
    }
    .shareInfo{
      width: 100%;
      height: 100px;
      display: flex;
      flex-direction: row;
      align-items: center;
      padding-left: 30px;
      position: relative;
      .userAvator{
        width: 70px;
        height: 70px;
        border-radius: 35px;
      }
      .avatortox{
        width: 70px;
        height: 70px;
        border-radius: 35px;
        line-height: 70px;
        font-size: 20px;
        font-weight: 700;
        color: #127DFB;
        text-align: center;
        background-color: #EBF3FB;
      }
      .info{
        margin-left: 10px;
        display: flex;
        flex-direction: column;
        .nav{
          display: flex;
          flex-direction: row;
          align-items: center;
          height: 28px;
          line-height: 28px;
          /deep/.el-breadcrumb{
            margin-left: 10px;
            .el-breadcrumb__inner{
              .ellipsis{
                font-size: 14px;
                color: #70798C;
              }
              .active{
                color:var(--key-color);
                font-weight: 600;
              }
            }
          }
        }
        .shareN{
          font-size: 12px;
          height: 25px;
          line-height: 25px;
          color: #70798C;
        }
      }
      .right{
        position: absolute;
        right: 10px;
        bottom: 0;
        width: 100px;
        height: 30px;
        display: flex;
        flex-direction: row;
        align-items: center;
        .icon{
          width: 16px;
          height: 16px;
          cursor: pointer;
          margin-left: 10px;
        }
      }
      .cursop,.fileName{
        cursor: pointer;
      }
    }
    .list,.listIcon{
      flex: 1 1;
      padding: 10px 20px;
    }
    .el-table{
      opacity: 0.95;
    }
    .fileName{
      display: flex;
      flex-direction: row;
      align-items: center;
      img{
        width: 22px;
        height: 22px;
        margin-right: 5px;
      }
    }
    .cursop,.fileName{
      cursor: pointer;
    }
    .listIcon{
      display: flex;
      flex-direction: row;
      flex-wrap:wrap;
      overflow-y: auto;
      .shareItem{
        width: 140px;
        height: 128px;
        float: left;
        padding: 10px;
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        img{
          width: 66px;
          height: 60px;
        }
        .name{
          width: 100%;
          font-size: 14px;
          font-weight: 500;
          color: var(--key-color);
          overflow: hidden;
          text-align: center;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        .listcheck{
          position: absolute;
          top: 10px;
          right: 10px;
        }
      }
      .shareItem:hover{
        background: rgba(235, 243, 251, 0.6);
      }
    }
  }
}
</style>
